import { TemplatePage } from './types';

const liveStreamWaveVideoTheme: TemplatePage = {
  header: {
    color: '#D3EEFF',
    icon: 'images/video-templates/wave-theme.jpg',
    title: 'Live Stream Templates — Company Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Company Theme',
    description_meta:
      'Make stunning design for your live streams with Company’s pack of branded templates. The set contains free transition screens, overlays, and more!',
    description:
      'Give your live streams a stylish & professional look with Company’s branded templates. You will get a set of pre-designed overlays and transition screens that perfectly fit multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.`
  },
  footer: {
    category: 'Live streaming Company theme',
    description:
      'With Company’s themed collections of editable templates, you will impress your viewers at ease! You will get a set containing a pre-designed countdown, intro, overlays, and transition screens to make your live streams look consistent and professional. Our packages also include templates for promo videos that will help you tangible boost your brand’s recognition. Leverage your live streaming business with no hard design skills!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming Company theme',
      search: { name: 'Company Theme', tags: 'Company Theme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamWaveVideoTheme;
